import React, { useEffect } from "react";
import { WordCloud } from '@antv/g2plot';
import useNavModel from "@/model/navModel";
import { homeService } from "./homeService";
import { useHomerModal } from "./homeModel";

export const Wordcloud = () => {
	const { addNav } = useNavModel(() => []);
	const { isRender, setIsRender } = useHomerModal();
	useEffect(() => {
		// console.log(isRender)
		if (!isRender) {
			setIsRender(true);
			homeService.wordCloudStatistics().then(res => {
				try {
					if (res && res.retData) {
						// console.log(isRender)
						let data = res.retData.map(item => ({ value: item.weight, name: item.name, list: item.list ?? [] }));
						const wordCloud = new WordCloud('home-content-center-wordCloud', {
							data,
							height: 464,
							wordField: 'name',
							weightField: 'value',
							colorField: 'name',
							wordStyle: {
								fontFamily: 'Verdana',
								fontSize: [8, 60], //字体的大小范围
								rotation: [0, 10],  //旋转的最小角度和最大角度 
							},

							// 设置多色
							color: ['#1F35F4', '#17FFFF', '#1C5C7B', "#184473", "#1AB4FF", "#162980"],
							//自定义模板
							tooltip: {
								//清除默认样式
								domStyles: {
									'g2-tooltip': { padding: 0, backgroundColor: " rgb(0, 0, 0,0)" }
								},
								customContent: (title, value) => {
									let { data } = value[0] ?? {};
									let str: string = '<div class="home-wordCloud-tooltip">';
									// console.log(data?.datum?.list ?? "无");
									if (data && data.datum) {
										str += `<span class="home-wordCloud-tooltip-title">关键词“${data.datum.name}”各网站分布</span>
											<div class="home-wordCloud-tooltip-content">`
										if (data.datum.list?.length > 0) {
											data.datum.list.forEach((item: any) => {
												str += `<div class="home-wordCloud-tooltip-content-item">
														<div class="item-1">
															<span>识别量：${item.distinguishNum ?? 0}条</span>
															<span>${item.name ?? ""}</span>
														</div>
														<div class="item-2">
															<span>过滤量：${item.filterNum ?? 0}条</span>
														</div>
													</div>`
											})
										} else {
											str += `<div class="home-wordCloud-tooltip-content-item">
													<div class="item-1">
														<span>无采集数据</span>
													</div>
												</div>`
										}

										str += "</div>"
									}
									str += "</div>";
									return str;
									// return `<div class="home-wordCloud-tooltip">
									// 			<span class="home-wordCloud-tooltip-title">关键词“车”各网站分布</span>
									// 			<div class="home-wordCloud-tooltip-content">
									// 				<div class="home-wordCloud-tooltip-content-item">
									// 					<div class="item-1">
									// 						<span>识别量：22条</span>
									// 						<span>中国交建</span>
									// 					</div>
									// 					<div class="item-2">
									// 						<span>过滤量:22条</span>
									// 					</div>
									// 				</div>
									// 				<div class="home-wordCloud-tooltip-content-item">
									// 					<div class="item-1">
									// 						<span>识别量：22条</span>
									// 						<span>中国交建</span>
									// 					</div>
									// 					<div class="item-2">
									// 						<span>过滤量:22条</span>
									// 					</div>
									// 				</div>
									// 				<div class="home-wordCloud-tooltip-content-item">
									// 					<div class="item-1">
									// 						<span>识别量：22条</span>
									// 						<span>中国交建</span>
									// 					</div>
									// 					<div class="item-2">
									// 						<span>过滤量:22条</span>
									// 					</div>
									// 				</div>
									// 				<div class="home-wordCloud-tooltip-content-item">
									// 					<div class="item-1">
									// 						<span>识别量：22条</span>
									// 						<span>中国交建</span>
									// 					</div>
									// 					<div class="item-2">
									// 						<span>过滤量:22条</span>
									// 					</div>
									// 				</div>
									// 			</div>
									// 		</div>`;
								}
							},

							// 返回值设置成一个 [0, 1) 区间内的值，
							// 可以让每次渲染的位置相同（前提是每次的宽高一致）。
							random: () => 0.5,
						});
						wordCloud.render();
						setIsRender(false);
						wordCloud.on('element:click', (...args: any) => {
							// console.log(...args);
							addNav("4")
						});
					}
				} catch (err) { }
			});

		}

	}, []);

	return <div className="home-content-center-wordCloud" id="home-content-center-wordCloud"></div>
}
